import styled from 'styled-components';

export const CustomButton = styled.button.attrs({ 'data-qa': 'custom-button' })`
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.carvana.blue.medium : theme.carvana.white.primary};
  border: 1px solid #d9dde9;
  border-radius: 3px;
  color: ${({ isSelected }) => (isSelected ? '#fff' : '#183558')};
  font-size: 14px;
  line-height: 20px;
  margin: 5px 0px;
  min-width: 0;
  padding: 10px 16px;
  width: 100%;

  div {
    overflow: hidden;
    pointer-events: none;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    color: ${({ isSelected, theme }) =>
      isSelected ? theme.carvana.blue.pastel : theme.carvana.gray.dark};
    font-size: 12px;
    line-height: 16px;
    pointer-events: none;
  }
`;

export const FlexContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
`;

export const TileTitle = styled.h4`
  font-size: 20px;
  font-weight: bold;
  line-height: 20px;
  margin-bottom: 12px;
  text-transform: uppercase;
`;

export const TileSubtitle = styled.div`
  color: #757989;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 12px;
  white-space: pre-line;
`;
